import EventBusService from '../EventBusService';
import EventBusEventName from '../EventBusService/EventBusEventName';

export type Feature = 'deals' | 'invoices' | 'projects';

export const showFeatureBreakdown = (feature: Feature, context: string) => {
  if (window.top) {
    EventBusService.dispatch(EventBusEventName.OnboardingFeatureBreakdownRequested, {
      feature,
      context,
    });
  } else {
    throw new Error('Window.top is not defined!');
  }
};

const OnboardingService = {
  showFeatureBreakdown,
};

export default OnboardingService;
